/* eslint-disable */

import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ProductCategory from './ProductCategory.js';
import ProductCategoryLicense from './ProductCategoryLicense.js';
import ProductCategoryLicenseForm from './ProductCategoryLicenseForm.js';
import ProductItem from './ProductItem.js';
import ProductItemPreview from './ProductItemPreview.js';

function Product(props) {
  return (
    <Routes>
      <Route
        path='/category'
        element={
          <ProductCategory
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
            isMobile={props.isMobile}
          />
        }
      />
      <Route
        path='/category/license/new'
        element={
          <ProductCategoryLicenseForm
            mode='create'
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
            isMobile={props.isMobile}
          />
        }
      />
      <Route
        path='/category/license/edit'
        element={
          <ProductCategoryLicenseForm
            mode='edit'
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
            isMobile={props.isMobile}
          />
        }
      />
      <Route
        path='/category/license'
        element={
          <ProductCategoryLicense
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
            isMobile={props.isMobile}
          />
        }
      />
      <Route
        path='/item'
        element={
          <ProductItem
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
            isMobile={props.isMobile}
          />
        }
      />
      <Route
        path='/itempreview'
        element={
          <ProductItemPreview
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
            isMobile={props.isMobile}
          />
        }
      />
    </Routes>
  );
}

export default Product;
